<template>
    <div class="landline-stepper">
        <div v-for="(step, i) in steps" class="step" :class="{ active: i < currentStep }">
            <div class="step-title">{{ i + 1 }}. {{ step.title }}</div>
            <div class="step-indicator"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: { type: Number, default: 1 },
    },

    data() {
        return {
            steps: [
                {
                    title: 'Login ',
                },
                {
                    title: 'Phone Number',
                },
                {
                    title: 'Enter Address',
                },
                {
                    title: 'Verify Ownership',
                },
                {
                    title: 'Sign the LOA',
                },
                {
                    title: 'Assign Number',
                },
                {
                    title: 'Migration',
                },
            ],
        };
    },

    methods: {
        init() {
            for (let i = 0; i < this.currentStep; i++) {
                this.steps[i].active = true;
            }
        },
    },

    mounted() {
        this.init();
    },
};
</script>
